import styled from 'styled-components';

export const Root = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  padding: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Box = styled.div`
  position: absolute;
  background-color: #fffff;
  border: 1px solid white;
  box-shadow: 1px 0px 0px 0px rgba(0; 0; 0; 0.3);
  opacity: 0;
  &:hover {
    opacity: 0.6;
  }
`

export const CanvasContainer = styled.canvas`
  width: 100%;
  height: 100%;
`

export const BoxContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const OptionsContainer = styled.div`
  position: absolute;
  padding-bottom: 6px;
  top: -26px;
  right: 0px;
`

export const MoveBox = styled.div`
  width: calc(100% - 2px);
  height: calc(100% - 2px);
`

export const CropMessage = styled.div`
  width: 40px;
  height: 20px;
  color: white;
  cursor: pointer;
  background-color: #000000DD;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
`

export const LeftSide = styled.div`
  position: absolute;
  top: -1.5px;
  left: -2.5px;
  width: 3px;
  height: calc(100% + 2px);
  display: flex;
  align-items: center;
`

export const RightSide = styled.div`
  position: absolute;
  top: -1.5px;
  right: -2.5px;
  width: 3px;
  height: calc(100% + 2px);
  color: white;
  display: flex;
  align-items: center;
`

export const TopSide = styled.div`
  position: absolute;
  top: -2.5px;
  left: -1.5px;
  width: calc(100% + 2px);
  height: 3px;
  color: white;
  display: flex;
  justify-content: center;
`

export const BottomSide = styled.div`
  position: absolute;
  bottom: -2.5px;
  left: -1.5px;
  width: calc(100% + 2px);
  height: 3px;
  color: white;
  display: flex;
  justify-content: center;
`

export const VerticalBarContainer = styled.div`
  height: calc(30% + 5px);
  width: calc(100% - 0px);
  background-color: white;
  cursor: ew-resize;
`

export const HorizontalBarContainer = styled.div`
  height: calc(100% - 0px);
  width: calc(30% + 5px);
  background-color: white;
  cursor: ns-resize;
`

export const VerticalBar = styled.div`
  height: 100%;
  width: 100%;
  background-color: white;
  boxShadow: 1px 1px 1px 1px rgba(0; 0; 0; 0.3);
`

export const HorizontalBar = styled.div`
  height: 100%;
  width: 100%;
  background-color: white;
  box-shadow: 1px 1px 1px 1px rgba(0; 0; 0; 0.3);
`

export const TextBoxContainer = styled.div`
  position: absolute;
  right: 0px;
  width: 200px;
  color: white;
  background-color: black;
  border-radius: 5px;
`

export const TextArea = styled.textarea`
  color: white;
  background-color: #FFFFFF00;
  border: 0px;
  resize: none;
  overflow: hidden;
  width: calc(100% - 10px);
  padding: 5px;
`